const Constant = {};


Constant.ProductStatus = {
  AV  : "AV",
  DL  : "DL",
}
Constant.CaseStatus = {
  ACTIVE: "active",
  CLOSED: "closed",
  ARCHIVED: "archived",
}

export default Constant;